/**
 * Iron Edge Garden Theme JavaScript
 * Core functionality for the theme
 */

(function() {
  'use strict';

  // Theme namespace
  window.theme = window.theme || {};

  /**
   * Cart functionality
   */
  theme.cart = {
    /**
     * Add item to cart
     */
    addItem: function(formData) {
      return fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json());
    },

    /**
     * Update cart count in header
     */
    updateCount: function() {
      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCount = document.getElementById('cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
          return cart;
        });
    },

    /**
     * Get cart data
     */
    getCart: function() {
      return fetch('/cart.js')
        .then(response => response.json());
    }
  };

  /**
   * Utility functions
   */
  theme.utils = {
    /**
     * Debounce function
     */
    debounce: function(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    /**
     * Format money
     */
    formatMoney: function(cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = window.theme.moneyFormat || '${{amount}}';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  };

  /**
   * Initialize theme
   */
  theme.init = function() {
    console.log('Iron Edge Garden theme initialized');
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', theme.init);
  } else {
    theme.init();
  }

})();
